<template>
    <div class="p-3">
        <soft-alert v-if="alert.state" :color="alert.color" class="mb-3">
            {{ alert.message }}
        </soft-alert>

        <form @submit.prevent="ejecuteDomus">
            <div class="row g-3">
                <div class="col-12">
                    <label class="form-label fw-semibold">Token</label>
                    <textarea
                        v-model="token"
                        class="form-control form-control-sm"
                        rows="4"
                        placeholder="Pega aquí el token de Domus"
                        required
                    ></textarea>
                </div>

                <div class="col-12">
                    <label class="form-label fw-semibold">Email</label>
                    <soft-input
                        v-model:value="email"
                        type="email"
                        placeholder="Correo electrónico"
                        aria-label="Correo electrónico"
                        required
                    />
                </div>

                <div class="col-12">
                    <label class="form-label fw-semibold">Inmobiliaria</label>
                    <soft-input
                        v-model:value="inmobiliaria"
                        type="number"
                        placeholder="ID de la inmobiliaria"
                        aria-label="ID de la inmobiliaria"
                        required
                    />
                </div>
            </div>

            <div class="d-flex justify-content-end mt-4">
                <soft-button
                    type="submit"
                    color="primary"
                    variant="gradient"
                    size="sm"
                    :loading="isLoading"
                >
                    <i class="fas fa-file-import me-1"></i> Importar
                </soft-button>
            </div>
        </form>
    </div>
</template>

<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import SoftInput from '@/components/SoftInput.vue';
import SoftButton from '@/components/SoftButton.vue';
import SoftAlert from '@/components/SoftAlert.vue';

export default {
    components: { SoftInput, SoftButton, SoftAlert },
    setup() {
        const store = useStore();

        const token = ref('');
        const email = ref('');
        const inmobiliaria = ref('');
        const isLoading = ref(false);
        const alert = ref({ state: false, message: '', color: 'success' });

        const showAlert = (message, color = 'success', timeout = 6000) => {
            alert.value = { state: true, message, color };
            setTimeout(() => { alert.value.state = false; }, timeout);
        };

        const ejecuteDomus = async () => {
            isLoading.value = true;
            try {
                await store.dispatch('appHelpers/storeRunGetPropertiesDomus', {
                    token: token.value,
                    email: email.value,
                    inmobiliaria: Number(inmobiliaria.value),
                });
                showAlert('Importación encolada correctamente. El proceso corre en segundo plano.', 'success');
            } catch (err) {
                const message = err?.response?.data?.message
                    || err?.response?.data?.errorMessage
                    || 'Error al conectar con Domus';
                showAlert(message, 'danger');
            } finally {
                isLoading.value = false;
            }
        };

        return { token, email, inmobiliaria, isLoading, alert, ejecuteDomus };
    },
};
</script>
